module.exports = __webpack_public_path__ + "img/aiNose-B01.60ac6f62.png";